import React from 'react';
import HeroFullEasyTranslator from '../components/sections/HeroFullEasyTranslator';
import Button from '../components/elements/Button';
import SectionHeader from '../components/sections/partials/SectionHeader';

class EasyTranslatorPage extends React.Component {
  state = {
    demoModalActive: false
  };

  openModal = (e) => {
    e.preventDefault();
    this.setState({ demoModalActive: true });
  };

  closeModal = (e) => {
    e.preventDefault();
    this.setState({ demoModalActive: false });
  };

  render() {
    return (
      <React.Fragment>
        <HeroFullEasyTranslator className="illustration-section-01" />
        <div className="container team section center-content">
          <div className="team-inner section-inner pt-0">
            <SectionHeader
              data={{
                title: 'Try Easy Translator for free today.'
              }}
              className="center-content"
              style={{ paddingBottom: 34 }}
            />
            <p>
              <Button
                tag="a"
                color="primary"
                wideMobile
                target="_blank"
                href="https://miro.com/marketplace/easy-translator/"
              >
                Install from the &nbsp;
                <img
                  src={require('./../assets/images/miro-logo.svg')}
                  alt="miro"
                  title="Available for Miro"
                />
                &nbsp; marketplace
              </Button>
            </p>
            <p>
              <Button
                tag="a"
                color="primary"
                wideMobile
                target="_blank"
                href="https://www.figma.com/community/plugin/1138160794213047497/Easy-Translator"
              >
                Install from the &nbsp;
                <img
                  src={require('./../assets/images/figma-logo.svg')}
                  alt="miro"
                  title="Available for Figma"
                />
                &nbsp; community&nbsp;&nbsp;&nbsp;&nbsp;
              </Button>
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EasyTranslatorPage;
